<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <vue-tabs @tab-change="handleTabChange" :ref="reference">
          <v-tab
            v-for="mod in tabLists"
            :key="mod.id"
            :title="translateDataBaseText(mod.name, mod.other_value)"
            :icon="mod.icon"
          >
          </v-tab>
          <router-view
            v-if="getMenuFromSessionStorage().length > 0"
            @showNotification="notifyVue"
            @cotentLoading="cotentLoading"
          ></router-view>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueTabs from 'vue-nav-tabs';
import MixinIndexTab from 'src/util/mixinIndexTab';
import MixinTranslate from 'src/util/mixinTranslate';

Vue.use(VueTabs);

export default {
  name: 'master-tab',
  mixins: [MixinIndexTab, MixinTranslate],
  data() {
    return {
      activeName: 'first',
      tabLists: [],
      shouldUpdateData: true,
      activeParent: null,
    };
  },
  props: {
    reference: {
      type: String,
      required: true,
    },
  },
  methods: {
    searchModuleByUrl() {
      const path = this.$route.path;
      const modules = this.$store.state.auth.user.all_modules;
      const user_modules = this.$store.state.auth.user.user_modules;
      let newOrderLevelThree = 0;
      const findModule = modules.find((module) => {
        return `/${module.url}`.trim() == path.trim();
      });

      if (findModule && this.activeParent != findModule.parent_module) {
        this.activeParent = findModule.parent_module;

        const result = modules.filter((element) => {
          if (
            element.level == 3 &&
            element.parent_module == this.activeParent &&
            user_modules.includes(element.id)
          ) {
            element.order = newOrderLevelThree++;
            return element;
          }
        });

        sessionStorage.setItem('levelThree', JSON.stringify(result));

        return result;
      } else return this.tabLists;
    },
  },
  updated() {
    this.setUpdated(this.$refs[this.reference]);
    if (this.shouldUpdateData) {
      this.shouldUpdateData = false;
      this.tabLists = this.searchModuleByUrl();
      setTimeout(() => {
        this.shouldUpdateData = true;
      }, 1000);
    }
  },
  mounted() {
    this.setMounted(this.$refs[this.reference]);
    this.tabLists = this.searchModuleByUrl();
  },
  destroyed() {
    this.setDestroyed();
  },
};
</script>
